import './Knowledge.css';
import React from "react";
import {Container, Row} from "react-bootstrap";


function Documentation(props) {

    const back = () => {
        props.history.push('/knowledge');
    }

    return (
        <Container className="container">
            <Row className="mt-4">
                <a href="" onClick={back} className="btn btn-outline-primary btn-sm">Back</a>
            </Row>
            <Row className="pb-1 pt-4">
                <h3>{props.history.location.header}</h3>
            </Row>
            <Row className="pb-4 pt-2">
                <ul>
                    {props.history.location.files.map(file =>
                        <li><a target="_blank" href={file.path} download>{file.name}</a>
                            <span>{!!file.description ? ':' : ''} {file.description}</span>
                        </li>
                    )}
                </ul>
            </Row>
        </Container>
    );
}

export default Documentation;